import {
    Component, ElementRef, NgZone, OnDestroy, OnInit, QueryList, ViewChildren, ViewChild, AfterViewChecked
} from '@angular/core';
import { Router } from '@angular/router';
import { AlertService, Alert } from 'ng-jhipster';

import { SaisineService } from './saisine.service';
import { RefusedMaster } from '../refused-master';
import { Saisine, SaisineStatus } from './saisine.model';
import { Mention } from './mention.model';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgForm } from '@angular/forms';

import { LoginService } from '../../shared/login/login.service';
import { LicenceSchool } from '../licence-school/licence-school.model';
import { UploadComponent } from '../../shared/upload/upload.component';
import { UploadProgressService } from '../../shared/upload/upload-progress.service';
import { Subscription } from 'rxjs';
import { isNullOrUndefined } from 'util';
import { UtilsService } from '../../shared/utils/utils.service';
import { Principal } from '../../shared/auth/principal.service';
import { AcademicDocument } from '../academic-document/academic-document.model';
import { ReportCard } from '../report-card/report-card.model';
import { MasterService } from '../master/master.service';
import { Master } from '../master/master.model';
import { Observable } from 'rxjs/Observable';
import { CampaignService } from '../campaign/campaign.service';
import { HomeService } from '../../home/home.service';
import { PropertiesService } from './properties.service';
import { SaisineCommentType } from '../saisine-comment/saisine-comment.model';
import { RegionService } from '../../admin/user-management/region.service';
import { LicenceToMaster } from '../master/licence-to-master.model';
import { LicenceToMasterService } from '../master/licence-to-master.service';
import { Title } from '@angular/platform-browser';
import { TranslateService } from 'ng2-translate';


@Component({
    selector: 'jhi-saisine-edit',
    templateUrl: './saisine-edit.component.html'
})
export class SaisineEditComponent implements OnInit, OnDestroy, AfterViewChecked {

    saisine: Saisine;
    authorities: ['ROLE_STUDENT'];
    birthDateDp: any;

    // If saisine saved
    saved = false;
    // date des campaigns
    lastThreeCampaigns: string[] = [];
    // date de la campagne

    messages: any;

    // date de delai entre 3 propositions (treated date) et la closure
    delay: number;

    // If save action is executed
    submitted = false;
    // If submit rectorat is executed
    submittedRectorat = false;

    // If saving is in progress, disable buttons
    isSaving = false;


    // Masters du referentiel
    masters: Master[];
    masterTitles = [];
    suggestedMasters: string[];

    // Mention
    mentions: Mention[];
    mentionLabels: string[] = [];
    suggestedMentionLabels: string[];
    licenceTitle: string;

    // Licence
    licenceSchools: LicenceSchool[] = [];
    licenceSchoolLabels: string[] = [];
    suggestedLicenceSchools: string[];
    licenceSchool: LicenceSchool;

    // Status Saisine
    saisineStatus: any = SaisineStatus;
    isSaisineDisabled = false;

    // CheckBoxes
    field_question1 = false;
    field_question2 = false;
    field_question3 = false;
    field_question4 = false;
    field_questionEnd = false;

    noSaisine = false;
    displaySaisineFromPreviousCampaign = false;

    // Alert
    alert: Alert;

    // Datepicker
    today = new Date();
    minDateDatePicker = { year: 1900, month: 1, day: 1 };
    maxDateDatePicker = { year: this.today.getFullYear(), month: this.today.getMonth() + 1, day: this.today.getDate() };

    // Uploads
    @ViewChildren(UploadComponent) uploads: QueryList<UploadComponent>;
    private percentCompletedSubscription: Subscription;
    percentCompleted = 0;

    @ViewChild('editForm') editForm: NgForm;

    focusRefusedMaster = false;
    focusAcademicDocument = false;
    focusReportCard = false;

    commentTypes: any = SaisineCommentType;

    visibleFormHandicapDisability: boolean;

    private subscription: Subscription = new Subscription();

    licenceToMasters: LicenceToMaster[];

    aDeuxUniversites: boolean;
    minNbDistinctMasters: number;
    minNbDistinctSchools: number;
    minNbCompatibleMasters: number;
    minNbRefusedMasters = 2;
    licenceMasterLabels = new Set<String>();

    constructor(
        private alertService: AlertService,
        private saisineService: SaisineService,
        private loginService: LoginService,
        private router: Router,
        private modalService: NgbModal,
        private uploadProgressService: UploadProgressService,
        private zone: NgZone,
        private elementRef: ElementRef,
        private utilsService: UtilsService,
        public principal: Principal,
        private masterService: MasterService,
        public campaignService: CampaignService,
        private homeService: HomeService,
        private propertiesService: PropertiesService,
        private regionService: RegionService,
        private licenceToMasterService: LicenceToMasterService,
        private translateService: TranslateService,
        private titleService: Title
    ) { }

    ngOnInit() {
        this.subscription.add(Observable.combineLatest(
            this.masterService.query({ 'campaign': this.campaignService.getCurrentCampaignYear() }),
            this.saisineService.getMentions({ 'campaign': this.campaignService.getCurrentCampaignYear() }),
            this.saisineService.getLicenceSchools(),
            this.homeService.getMessages(),
            this.regionService.getRegions({ 'campaign': this.campaignService.getCurrentCampaignYear() }),
            this.licenceToMasterService.query()
        ).subscribe(([masters, mentions, licenceSchools, messages, regions, licenceToMasters]) => {

                // MASTERS
                this.masters = masters.json() as Master[];
                for (let master of this.masters) {
                    this.masterTitles.push(master.masterTitle);
                }

                // MENTIONS
                this.mentions = mentions;
                this.mentionLabels = this.mentions.map(m => m.mentionLabel);

                // LICENCE SCHOOLS
                this.licenceSchools = licenceSchools;
                this.licenceSchoolLabels = this.licenceSchools.map(ls => ls.schoolLabel);

                this.licenceToMasters = licenceToMasters;
                this.licenceToMasters.forEach(l2m => {
                    l2m.masterLabel = this.cleanString(l2m.masterLabel);
                    l2m.mentionLabel = this.cleanString(l2m.mentionLabel);
                });

                // Campaigns
                let campaignYear = Number(this.campaignService.getCurrentCampaignYear());
                for (let i = 0; i < 3; i++) {
                    let currentYear = campaignYear - i;
                    let previousYear = currentYear - 1;
                    this.lastThreeCampaigns.push(previousYear + ' - ' + currentYear);
                }

                this.delay = Number(this.propertiesService.properties.delay);

                // SAISINES
                this.subscription.add(this.saisineService.findStudentSaisine().subscribe(saisine => {
                    this.updateSaisine(saisine);
                }, error => {
                    if (error.status === 404) {
                        if (this.campaignService.isObjectFromCurrentCampaign(this.principal.getIdentity().campaign) && this.campaignService.isCurrentCampaignOpen()) {
                            let saisine = new Saisine;
                            saisine.campaign = this.principal.getIdentity().campaign;
                            saisine.student = {
                                'email': this.principal.getIdentity().email,
                                'id': this.principal.getIdentity().id,
                                'langKey': this.principal.getIdentity().langKey,
                                'schoolLeader': false,
                                'activated': this.principal.getIdentity().activated
                            };
                            saisine.status = SaisineStatus.IN_PROGRESS;
                            this.updateSaisine(saisine);
                        } else {
                            this.noSaisine = true;
                        }
                    } else {
                        console.log(error);
                        this.onError(error);
                    }
                }));
                Object.keys(messages).forEach(messageKey => {
                    messages[messageKey] = messages[messageKey].replace(/{{currentCampaign}}/g, this.campaignService.getCurrentCampaignYear());
                    messages[messageKey] = messages[messageKey].replace(/{{nextCampaign}}/g, this.campaignService.getNextCampaignYear());
                    messages[messageKey] = messages[messageKey].replace(/{{currentOrNextOpenCampaign}}/g, this.campaignService.getNextOpenCampaignYear());
                });
                this.messages = messages;
            }));

        this.percentCompletedSubscription = this.uploadProgressService.percentCompleted.subscribe(
            p => {
                // To enable view refresh.
                this.zone.run(() => {
                    this.percentCompleted = p;
                });
            }
        );

        this.visibleFormHandicapDisability = ('true' === this.propertiesService.properties.visibleFormHandicapDisability);
    }

    ngOnDestroy() {
        if (this.percentCompletedSubscription) { this.percentCompletedSubscription.unsubscribe(); }
        if (this.subscription) { this.subscription.unsubscribe(); }
    }

    ngAfterViewChecked() {
        if (this.focusRefusedMaster) {
            this.focusRefusedMaster = false;
            setTimeout(_ => {
                let inputRefusedMasterItems = this.elementRef.nativeElement.querySelectorAll('input.inputRefusedMaster');
                if (!isNullOrUndefined(inputRefusedMasterItems) && !isNullOrUndefined(inputRefusedMasterItems[inputRefusedMasterItems.length - 1])) {
                    inputRefusedMasterItems[inputRefusedMasterItems.length - 1].focus();
                }
            });
        }
        if (this.focusAcademicDocument) {
            this.focusAcademicDocument = false;
            setTimeout(_ => {
                let inputAcademicDocumentItems = this.elementRef.nativeElement.querySelectorAll('input.inputAcademicDocument');
                if (!isNullOrUndefined(inputAcademicDocumentItems) && !isNullOrUndefined(inputAcademicDocumentItems[inputAcademicDocumentItems.length - 1])) {
                    inputAcademicDocumentItems[inputAcademicDocumentItems.length - 1].focus();
                }
            });
        }
    }

    load(scrollToTop = true) {
        this.subscription.add(this.saisineService.findStudentSaisine().subscribe(saisine => {
            this.updateSaisine(saisine, scrollToTop);
        }));
    }

    updateSaisine(saisine: Saisine, scrollToTop = true) {
        if (!saisine.disabilityResponses) {
            saisine.disabilityResponses = {};
        }
        this.updateTitle(saisine);
        this.saisine = saisine;
        if (this.saisine.campaign !== this.campaignService.getCurrentCampaignYear() || (this.saisine.status !== SaisineStatus.IN_PROGRESS && this.saisine.status !== SaisineStatus.REJECTED)) {
            this.isSaisineDisabled = true;
        }
        if (!isNullOrUndefined(saisine.id)) {
            this.field_question1 = this.field_question2 = this.field_question3 = this.field_question4 = this.field_questionEnd = true;
            this.saisine.birthDate = {
                year: this.saisine.birthDate.getFullYear(),
                month: this.saisine.birthDate.getMonth() + 1,
                day: this.saisine.birthDate.getDate()
            };
            this.initMasterToLibelleMaster();
            this.checkLicenceTitleInList();
            this.setLicenceSchoolsPropertiesInSaisine();
        }
        this.saisine.reportCards.push(new ReportCard);
        if (scrollToTop) {
            setTimeout(() => {
                this.utilsService.scrollToTop();
                let statusEls = document.getElementsByName('saisine-status');
                if (statusEls.length > 0) {
                    statusEls[statusEls.length - 1].focus();
                }
            }, 0);
        }
    }

    addRefusedMaster() {
        if (!this.isSaisineDisabled) {
            let refusedMaster = new RefusedMaster(null, null, null, null);
            this.saisine.refusedMasters.push(refusedMaster);
            this.focusRefusedMaster = true;
        }
    }

    removeRefusedMaster(i: number) {
        if (!this.isSaisineDisabled) {
            this.saisine.refusedMasters.splice(i, 1);
        }
    }

    addAcademicDocument() {
        if (!this.isSaisineDisabled) {
            let academicDocument = new AcademicDocument(null, '');
            this.saisine.academicDocuments.push(academicDocument);
            this.focusAcademicDocument = true;
        }
    }

    addReportCard() {
        if (!this.isSaisineDisabled) {
            this.saisine.reportCards.push(new ReportCard(null));
        }
    }

    removeAcademicDocument(i: number) {
        if (!this.isSaisineDisabled) {
            this.saisine.academicDocuments.splice(i, 1);
        }
    }

    removeReportCardHandler = (i: number) => {
        this.removeReportCard(i);
    }

    removeReportCard(i: number) {
        if (!this.isSaisineDisabled) {
            this.saisine.reportCards.splice(i, 1);
        }
    }

    logout() {
        this.loginService.logout();
        this.router.navigate(['/']);
    }

    save(status: SaisineStatus) {
        if (!this.isSaisineDisabled) {
            this.submitted = true;
            this.submittedRectorat = false;
            this.setLicenceSchoolsPropertiesInSaisine();
            this.setMasterInRM();
            // Suppression reportCard vide
            this.saisine.reportCards = this.saisine.reportCards.filter(_ => !isNullOrUndefined(_.blobId));
            // Puis du reste
            // Je focus sur l'element invalid si focus invalid = true
            // Sinon (false), continuer a save
            Observable.timer(0).subscribe((t) => {
                if (this.checkRefusedMasters() && !this.isStillErrorOnForm()) {
                    this.isSaving = true;
                    let copy: Saisine = Object.assign({}, this.saisine);
                    if (!isNullOrUndefined(status)) {
                        copy.status = status;
                    }
                    if (this.saisine.id) {
                        this.saisineService.update(copy).subscribe(this.onSaveSuccess, this.onSaveError);
                    } else {
                        this.saisineService.create(copy).subscribe(this.onSaveSuccess, this.onSaveError);
                    }
                }
            });
        }
    }

    checkLicenceTitleInList(): void {
        this.licenceTitle = this.mentionLabels.find(label => label === this.saisine.licenceTitle);

        this.licenceMasterLabels = new Set(this.licenceToMasters.filter(l2m => l2m.mentionLabel === this.cleanString(this.saisine.licenceTitle)).map(_ => _.masterLabel));
    }

    initMasterToLibelleMaster() {
        this.saisine.refusedMasters.forEach(rm => {
            if (!isNullOrUndefined(rm.master)) {
                rm.masterTitle = this.masterService.getMasterTitle(rm.master);
            }
        });
    }

    checkRefusedMasters(): boolean {
        return !this.saisine.refusedMasters || this.saisine.refusedMasters.every(rmaster => !isNullOrUndefined(rmaster.master));
    }

    isStillErrorOnForm(): boolean {
        let invalidItems = this.elementRef.nativeElement.querySelectorAll('input.ng-invalid, p-autocomplete.ng-invalid input, small.text-danger');
        for (let invalidItem of invalidItems) {
            if (!isNullOrUndefined(invalidItem) && !invalidItem.hidden) {
                invalidItem.focus();
                invalidItem.scrollIntoView({ block: 'center' });
                return true;
            }
        }
        return false;
    }

    setLicenceSchoolsPropertiesInSaisine(): void {
        this.licenceSchool = this.licenceSchools.find(licence => this.saisine.licenceSchoolLabel === licence.schoolLabel);
        // Si les labels sont égaux ( l'etudiant a bien utilisé la datalist ) alors on met ces champs dans la saisine
        // Sinon ils sont a null
        if (this.licenceSchool) {
            this.saisine.licenceAcademicRegionLabel = this.licenceSchool.academicRegionLabel;
            this.saisine.licenceAcademyCode = this.licenceSchool.academyCode;
            this.saisine.licenceAcademyLabel = this.licenceSchool.academyLabel;
            this.saisine.licenceSchoolUai = this.licenceSchool.schoolUai;
        } else {
            this.saisine.licenceAcademicRegionLabel =
                this.saisine.licenceAcademyCode =
                this.saisine.licenceAcademyLabel =
                this.saisine.licenceSchoolUai = null;
        }
        let saisineRegion = this.regionService.regions.find(r => r.academicRegionLabel === this.saisine.licenceAcademicRegionLabel);
        this.aDeuxUniversites = saisineRegion ? saisineRegion.aDeuxUniversites : false;
        this.minNbRefusedMasters = this.aDeuxUniversites ? Number(this.propertiesService.properties.minNbRefusedMasters) : 2;
        this.minNbDistinctSchools = this.aDeuxUniversites ? Number(this.propertiesService.properties.minNbDistinctSchools) : undefined;
        this.minNbDistinctMasters = this.aDeuxUniversites ? Number(this.propertiesService.properties.minNbDistinctMasters) : undefined;
        this.minNbCompatibleMasters = this.aDeuxUniversites ? Number(this.propertiesService.properties.minNbCompatibleMasters) : undefined;
    }

    setMasterInRM(): void {
        this.saisine.refusedMasters.forEach(rm => {
            rm.master = this.masters.find(master => rm.masterTitle === master.masterTitle);
        });
    }

    // this binding
    onSaveSuccess = (result: Saisine) => {
        this.isSaving = false;
        this.saved = true;
        Object.keys(this.editForm.controls).forEach(control => {
            this.editForm.controls[control].markAsPristine();
        });
        this.updateSaisine(result);
    }

    // this binding
    onSaveError = (error) => {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alert = this.alertService.error(error.message, null, null);
    }

    // modal
    saisir(content) {
        this.submitted = true;
        this.submittedRectorat = true;
        this.setLicenceSchoolsPropertiesInSaisine();
        this.setMasterInRM();
        Observable.timer(0).subscribe((t) => {
            if (!this.isStillErrorOnForm() && this.canSaisirMonRectorat()) {
                this.modalService.open(content).result.then((result) => {
                    this.save(SaisineStatus.TO_CHECK);
                }, (reason) => { });
            }
        });
    }

    // modal abandoned
    abandon(contentAbandon) {
        this.modalService.open(contentAbandon).result.then((result) => {
            this.subscription.add(this.saisineService.abandon(this.saisine).subscribe(s => this.updateSaisine(s)));
        }, (reason) => {
        });
    }

    canSaisirMonRectorat(): boolean {
        return !this.isUploading()
            && this.saisine.cvDocumentUserBlobFilename != null
            && this.saisine.motivationLetterUserBlobFilename != null
            && this.saisine.licenceDocumentUserBlobFilename != null
            && this.isRefusedMastersFilesUploaded()
            && this.isAcademicDocumentsFilesUploaded()
            && this.isReportCardsFilesUploaded()
            && this.saisine.refusedMasters
            && this.saisine.numberRefusedMaster === this.saisine.refusedMasters.length
            && this.isRefusedMastersDistinct()
            && this.isRefusedMasterSchoolsDistinct();
    }

    isRefusedMastersFilesUploaded(): boolean {
        return this.saisine.refusedMasters.every(rmaster => !isNullOrUndefined(rmaster.refusalDocumentUserBlobId));
    }

    isRefusedMastersDistinct(): boolean {
        return !this.minNbDistinctMasters
            || !this.saisine.refusedMasters
            || new Set(this.saisine.refusedMasters.filter(_ => _.master).map(_ => this.cleanString(_.master.masterLabel))).size >= this.minNbDistinctMasters;
    }

    isRefusedMasterSchoolsDistinct(): boolean {
        return !this.minNbDistinctSchools
            || !this.saisine.refusedMasters
            || new Set(this.saisine.refusedMasters.filter(_ => _.master).map(_ => _.master.masterSchoolUai)).size >= this.minNbDistinctSchools;
    }

    isAcademicDocumentsFilesUploaded(): boolean {
        if (this.saisine.academicDocuments.length > 0) {
            return this.saisine.academicDocuments.every(academ => !isNullOrUndefined(academ.academicDocumentUserBlobId));
        } else {
            return true;
        }
    }

    isReportCardsFilesUploaded(): boolean {
        // Il faut au moins un doc avec un blobId non null/undefined
        if ((this.saisine.reportCards.length) > 0) {
            return this.saisine.reportCards.some(rc => !isNullOrUndefined(rc.blobId));
        } else {
            return false;
        }
    }

    isUploading() {
        if (this.uploads) {
            return this.uploads.some(up => up.uploading);
        } else {
            return false;
        }
    }


    isDateValid(date: any) {
        if (isNullOrUndefined(date)) {
            return false;
        } else {
            let dateObj = new Date(date.year, date.month - 1, date.day);
            return (dateObj
                && (date.year === dateObj.getFullYear())
                && ((date.month - 1) === dateObj.getMonth())
                && (date.day === dateObj.getDate()));
        }
    }

    showSaisineFromPreviousCampaign(): void {
        this.displaySaisineFromPreviousCampaign = true;
    }

    cleanString(text) {
        return text.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]/g, '');
    }
    updateTitle(saisine: Saisine) {
        if (!this.campaignService.isObjectFromCurrentCampaign(this.principal.getIdentity().campaign)) {
            this.titleService.setTitle('Campagne close');
        } else {
            this.titleService.setTitle(this.translateService.instant('tmmsaisineApp.saisine.home.createOrEditLabel') + ' - ' + this.translateService.instant('tmmsaisineApp.saisine.home.titleSaisineInfos.' + SaisineStatus[saisine.status + '']));
        }
    }
}




// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-edit.component.ts